<template>
  <div class="campo">
    <fai
      :icon="['far', 'envelope']"
      transform="shrink-4"
      style="color: #0053a2;"
    />
    <span v-if="valor">{{ valor }}</span>
    <CampoVacio v-else mensaje="(sin email)" />
  </div>
</template>

<script>
export default {
  props: {
    valor: { type: String, required: false, default: null }
  }
};
</script>

<style scoped>
.campo {
  padding-bottom: 0.5rem;
}
</style>
